import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AppUser = {
  __typename?: 'AppUser';
  getUserScenarios: Array<UserScenario>;
  id: Scalars['String'];
};

/** A basic product with only the common fields */
export type BasicProduct = Product & {
  __typename?: 'BasicProduct';
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']>;
  /** The uuid of the product */
  id: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  /** The human readable name of the visual door */
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  /** The type of the product */
  productType: Scalars['String'];
  /** Optional filter style on the rendering context of the canvas */
  renderingContextFillStyle?: Maybe<Scalars['String']>;
  /** Optional css filter on the rendering context of the canvas */
  renderingContextFilter?: Maybe<Scalars['String']>;
  showForAllDoors?: Maybe<Scalars['Boolean']>;
  showForDoorTypes?: Maybe<Array<DoorType>>;
  /** The thumbnail image of the visual door */
  thumbnailImage?: Maybe<Image>;
  visualDoors: Array<VisualDoor>;
  /** The full image of the visual door */
  visualisationImage: Image;
  /** 0 represents the door itself, negative numbers mean the product is visualised behind the door, positive numbers mean the product is visualised in front of the door */
  visualisationLayer?: Maybe<Scalars['Float']>;
};

export type CategoryOptionsToSelect = {
  __typename?: 'CategoryOptionsToSelect';
  categoryId: Scalars['String'];
  optionsToSelect?: Maybe<Array<Scalars['String']>>;
  selectAllOptions?: Maybe<Scalars['Boolean']>;
};

export type ColorInput = {
  imageButtonsBackground?: InputMaybe<Scalars['String']>;
  imageButtonsText?: InputMaybe<Scalars['String']>;
  primary?: InputMaybe<Scalars['String']>;
  primaryText?: InputMaybe<Scalars['String']>;
  uploadPanelBackground?: InputMaybe<Scalars['String']>;
  uploadPanelText?: InputMaybe<Scalars['String']>;
};

export type CornerPosition = {
  __typename?: 'CornerPosition';
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type CornerPositionInput = {
  x: Scalars['Int'];
  y: Scalars['Int'];
};

export type CreateOrUpdateShadowProfileInputArguments = {
  shadowImages?: InputMaybe<Array<ShadowImagesInput>>;
  shadowProfileId?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
};

export type CreateScenarioResponse = {
  __typename?: 'CreateScenarioResponse';
  showCornerRefinement: Scalars['Boolean'];
  userScenario: UserScenario;
};

export type CreateUserScenarioParameters = {
  /** The customer key for which this user scenario should be created */
  customerKey: Scalars['String'];
  /** The device type used to create/upload this user scenario */
  deviceType?: InputMaybe<DeviceType>;
  /** Specify the start and end of the door location it the uploaded image is horizontal */
  doorLocation?: InputMaybe<DoorLocation>;
  doorType?: InputMaybe<DoorType>;
  /** File upload if the user uses an own photo */
  fileUpload: Scalars['Upload'];
  imageOrientation?: InputMaybe<ImageOrientation>;
};

export type CreateVisualDoorParameters = {
  customAttributeValues?: InputMaybe<Array<CustomAttributeValueInput>>;
  /** The type of the visual door */
  doorType?: InputMaybe<DoorType>;
  enabled: Scalars['Boolean'];
  externalIds?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['Upload']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<MonetaryValueInput>;
  /** The link which should be opened when the user clicks shop now */
  showNowLink: Scalars['String'];
};

/** CursorBasedPageInfo */
export type CursorBasedPageInfoModel = {
  __typename?: 'CursorBasedPageInfoModel';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
};

export type CustomAttribute = {
  __typename?: 'CustomAttribute';
  id: Scalars['String'];
  name: Scalars['String'];
  optional: Scalars['Boolean'];
  order?: Maybe<Scalars['Int']>;
  type: CustomAttributeType;
};

export type CustomAttributeInput = {
  attributeName: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type CustomAttributeSaveInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  optional: Scalars['Boolean'];
  order?: InputMaybe<Scalars['Int']>;
  type: CustomAttributeType;
};

export enum CustomAttributeType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Enum = 'ENUM',
  Number = 'NUMBER',
  String = 'STRING'
}

export type CustomAttributeValue = {
  __typename?: 'CustomAttributeValue';
  customAttribute: CustomAttribute;
  value?: Maybe<Scalars['String']>;
};

export type CustomAttributeValueInput = {
  customAttributeId: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

/** A customer which provides us with there visual doors and links to our tool from there web shop. */
export type Customer = {
  __typename?: 'Customer';
  applicationUrl: Scalars['String'];
  config: CustomerConfig;
  /** Delivers example images for the customer if a user has no image at hand. */
  exampleImages: ExampleImagesResponse;
  /** The homepage URL of the customer. Used as a link destination when clicking on the customer logo in the app */
  homepageUrl?: Maybe<Scalars['String']>;
  /** The uuid identifying the customer. */
  id: Scalars['String'];
  isInMaintenance?: Maybe<Scalars['Boolean']>;
  /** The unique human readable key of the customer. */
  key: Scalars['String'];
  /** The logo SVG stored in the admin application. Use the logoPath on the customer config resolver to get the logo for which should be used in the application */
  logoSvg?: Maybe<Scalars['String']>;
  /** The name of the customer. */
  name: Scalars['String'];
  statistics: CustomerStatistics;
  visualDoorProvider: VisualDoorProvider;
  widgetUrl: Scalars['String'];
};


/** A customer which provides us with there visual doors and links to our tool from there web shop. */
export type CustomerStatisticsArgs = {
  daysInPast?: InputMaybe<Scalars['Float']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerColor = {
  __typename?: 'CustomerColor';
  imageButtonsBackground?: Maybe<Scalars['String']>;
  imageButtonsText?: Maybe<Scalars['String']>;
  primary?: Maybe<Scalars['String']>;
  primaryText?: Maybe<Scalars['String']>;
  uploadPanelBackground?: Maybe<Scalars['String']>;
  uploadPanelText?: Maybe<Scalars['String']>;
};

export type CustomerConfig = {
  __typename?: 'CustomerConfig';
  /** Determines if the customer is active or not */
  active: Scalars['Boolean'];
  allowClippedCorners?: Maybe<Scalars['Boolean']>;
  allowMultipleDoors?: Maybe<Scalars['Boolean']>;
  alwaysShowImageButtons?: Maybe<Scalars['Boolean']>;
  colors?: Maybe<CustomerColor>;
  cssPath: Scalars['String'];
  customAttributes: Array<CustomAttribute>;
  defaultDoorType: DoorType;
  /** The defaultLanguage of the customer */
  defaultLanguage: Scalars['String'];
  disableProductOrdering?: Maybe<Scalars['Boolean']>;
  disableVisualDoorsOrdering?: Maybe<Scalars['Boolean']>;
  enableDoorTypeDropdownSelection?: Maybe<Scalars['Boolean']>;
  enableShadowInpainting?: Maybe<Scalars['Boolean']>;
  enableVisualDoorsSearch?: Maybe<Scalars['Boolean']>;
  enabledExampleImageSets?: Maybe<Scalars['Boolean']>;
  /** Determines if the products are enabled */
  enabledProducts?: Maybe<Scalars['Boolean']>;
  enabledShadowProfiles: Scalars['Boolean'];
  gtmTag?: Maybe<Scalars['String']>;
  hideDownloadButton?: Maybe<Scalars['Boolean']>;
  hideFlipButton?: Maybe<Scalars['Boolean']>;
  hideRefineButtonUnderImage?: Maybe<Scalars['Boolean']>;
  hideShareButton?: Maybe<Scalars['Boolean']>;
  /** The uuid identifying the customer config. */
  id: Scalars['String'];
  imageButtonsArrangement: ImageButtonsArrangement;
  imageButtonsPlacement: ImageButtonsPlacement;
  logoPath?: Maybe<Scalars['String']>;
  logoPlacement: LogoPlacement;
  logoSvgForApplication?: Maybe<Scalars['String']>;
  mainDoorTypeFilter?: Maybe<Array<DoorType>>;
  productLinkType: ProductLinkType;
  shopLinkOverwrite?: Maybe<Scalars['String']>;
  showCustomAttributesFilter?: Maybe<Scalars['Boolean']>;
  /** Determines if the door vision branding should be shown */
  showDoorVisionBranding: Scalars['Boolean'];
  showGlassLayerInVisualization: Scalars['Boolean'];
  showRefineLayoutAfterUpload: Scalars['Boolean'];
  /** Determines if the user scenario graphs are shown in the overview */
  showUserScenarioGraphsInOverview?: Maybe<Scalars['Boolean']>;
  /** Determines if the user scenario counts are shown in the user scenarios tab */
  showUserScenariosCounts?: Maybe<Scalars['Boolean']>;
  showVisitHomepageButton?: Maybe<Scalars['Boolean']>;
  supportedDoorTypes: Array<DoorType>;
  supportedProductTypes?: Maybe<Array<Scalars['String']>>;
  translations?: Maybe<Scalars['String']>;
  translationsPath: Scalars['String'];
  /** Determines if example images should be used or not */
  useExampleImages: Scalars['Boolean'];
  /** Determines if the favorites list should be used */
  useFavoritesList: Scalars['Boolean'];
};

export type CustomerSpecificParameters = {
  directDoorsProperties?: InputMaybe<DirectDoorsVisualDoorInputParameters>;
};

export type CustomerStatistics = {
  __typename?: 'CustomerStatistics';
  activeUsers: Scalars['Float'];
  renderings: Scalars['Float'];
  uploads: Scalars['Float'];
};

export enum DeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type DirectDoorsVisualDoorInputParameters = {
  collection: Scalars['String'];
  finish: Scalars['String'];
  type: Scalars['String'];
};

export type DirectDoorsVisualDoorParameters = {
  __typename?: 'DirectDoorsVisualDoorParameters';
  collection: Scalars['String'];
  finish: Scalars['String'];
  type: Scalars['String'];
};

/** Specifies the position of the door corners */
export type DoorCorners = {
  __typename?: 'DoorCorners';
  bottomLeft: CornerPosition;
  bottomRight: CornerPosition;
  doorType: DoorType;
  index: Scalars['Int'];
  topLeft: CornerPosition;
  topRight: CornerPosition;
};

export type DoorCornersInput = {
  bottomLeft: CornerPositionInput;
  bottomRight: CornerPositionInput;
  doorType: DoorType;
  index: Scalars['Int'];
  topLeft: CornerPositionInput;
  topRight: CornerPositionInput;
};

export type DoorLocation = {
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export enum DoorType {
  Double = 'DOUBLE',
  Entry = 'ENTRY',
  Exterior = 'EXTERIOR',
  ExteriorDouble = 'EXTERIOR_DOUBLE',
  Floor = 'FLOOR',
  Front = 'FRONT',
  Garage = 'GARAGE',
  GarageDouble = 'GARAGE_DOUBLE',
  Gliding = 'GLIDING',
  Interior = 'INTERIOR',
  InteriorDouble = 'INTERIOR_DOUBLE',
  Patio = 'PATIO',
  Single = 'SINGLE'
}

export type DoorTypeFilterOption = {
  __typename?: 'DoorTypeFilterOption';
  description: Scalars['String'];
  doorType: DoorType;
  svgImageUrl?: Maybe<Scalars['String']>;
};

export type EmailLog = {
  __typename?: 'EmailLog';
  aws_message_id?: Maybe<Scalars['String']>;
  body_html?: Maybe<Scalars['String']>;
  body_text: Scalars['String'];
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  provider: EmailProvider;
  provider_payload?: Maybe<Scalars['String']>;
  status: EmailStatus;
  subject: Scalars['String'];
  to: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};

export type EmailLogFilter = {
  from?: InputMaybe<Scalars['String']>;
  fromCreatedAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<EmailStatus>;
  to?: InputMaybe<Scalars['String']>;
  toCreatedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['String']>;
};

export type EmailLogPaginationModel = {
  __typename?: 'EmailLogPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<EmailLog>>;
};

export enum EmailProvider {
  AwsSes = 'AWS_SES',
  Local = 'LOCAL'
}

export enum EmailStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sent = 'SENT'
}

export type EventFilterInput = {
  appUserId?: InputMaybe<Scalars['Float']>;
  customerKeys?: InputMaybe<Scalars['String']>;
  eventNames?: InputMaybe<Scalars['String']>;
  exampleImageId?: InputMaybe<Scalars['Float']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  productExternalId?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  userScenarioId?: InputMaybe<Scalars['Float']>;
};

export enum EventInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type EventsCountByDate = {
  __typename?: 'EventsCountByDate';
  count: Scalars['Float'];
  date: Scalars['DateTime'];
};

/** An example image provided by us to show case the app without making a photo. */
export type ExampleImage = {
  __typename?: 'ExampleImage';
  /** The corners of the example image. */
  corners: Array<DoorCorners>;
  customData?: Maybe<Scalars['String']>;
  /** The door type for which this example image is made for. */
  doorType: DoorType;
  /** The uuid identifying the example image. */
  id: Scalars['String'];
  /** The full sized image. */
  image: Image;
  /** The position of the light in the example image */
  lightPosition: LightPosition;
  /** Location and intensity of light sources */
  lightSourceParameters: Array<LightSourcesParameters>;
  /** The orientation of the example image */
  orientation: ImageOrientation;
  /** The shadow image of the example image */
  shadowImage?: Maybe<Image>;
  /** The shortId identifying the example image. */
  shortId: Scalars['String'];
  /** A small thumbnail image which should be used to preview the example image in a list etc. */
  thumbnail: Image;
  usageCount: Scalars['Float'];
};

export type ExampleImageOrderInput = {
  id: Scalars['String'];
  order: Scalars['Float'];
};

export type ExampleImageSet = {
  __typename?: 'ExampleImageSet';
  /** The uuid identifying the example image set. */
  id: Scalars['String'];
  /** The name of the example image set. */
  name?: Maybe<Scalars['String']>;
  /** The number of the example image set. */
  nr: Scalars['Float'];
  thumbnail?: Maybe<Image>;
};

export type ExampleImagesResponse = {
  __typename?: 'ExampleImagesResponse';
  horizontals: Array<ExampleImage>;
  verticals: Array<ExampleImage>;
};

/** Represents the filter context */
export type FilterContextInput = {
  /** The custom attributes the user selected */
  customAttributes?: InputMaybe<Array<CustomAttributeInput>>;
  /** The door type the user selected, will default to the customers default door type if not set */
  doorType?: InputMaybe<DoorType>;
  /** The selected options for each filter category */
  filterFor?: InputMaybe<Array<SelectedFilteCategoryOptions>>;
  onlyFavorites?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the referral visual door */
  referralVisualDoorExternalId?: InputMaybe<Scalars['String']>;
  /** The sorting id which should be used to sort the visual doors */
  sortBy?: InputMaybe<Scalars['String']>;
};

/** A product representing a door frame */
export type FrameProduct = Product & {
  __typename?: 'FrameProduct';
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']>;
  /** The height of the door frame */
  height?: Maybe<Scalars['Float']>;
  /** The uuid of the product */
  id: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  /** The human readable name of the visual door */
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  /** The type of the product */
  productType: Scalars['String'];
  /** Optional filter style on the rendering context of the canvas */
  renderingContextFillStyle?: Maybe<Scalars['String']>;
  /** Optional css filter on the rendering context of the canvas */
  renderingContextFilter?: Maybe<Scalars['String']>;
  showForAllDoors?: Maybe<Scalars['Boolean']>;
  showForDoorTypes?: Maybe<Array<DoorType>>;
  /** The thumbnail image of the visual door */
  thumbnailImage?: Maybe<Image>;
  visualDoors: Array<VisualDoor>;
  /** The full image of the visual door */
  visualisationImage: Image;
  /** 0 represents the door itself, negative numbers mean the product is visualised behind the door, positive numbers mean the product is visualised in front of the door */
  visualisationLayer?: Maybe<Scalars['Float']>;
  /** The width of the door frame */
  width?: Maybe<Scalars['Float']>;
};

export type GetEventCountsPerIntervalInput = {
  customerKey: Scalars['String'];
  eventInterval: EventInterval;
  eventNames?: InputMaybe<Array<Scalars['String']>>;
  intervalCount?: InputMaybe<Scalars['Int']>;
};

/** A hero filter represents a collection of category filter options which can be selected by the user via a single click on the hero image */
export type HeroFilterOption = {
  __typename?: 'HeroFilterOption';
  categoryOptionsToSelect?: Maybe<Array<CategoryOptionsToSelect>>;
  description?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  title: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  /** The uuid identifying the image. */
  id: Scalars['String'];
  /** The url to the image */
  url: Scalars['String'];
};

export enum ImageButtonsArrangement {
  Line = 'LINE',
  Stacked = 'STACKED'
}

export enum ImageButtonsPlacement {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum ImageOrientation {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type ImportResult = {
  __typename?: 'ImportResult';
  createdVisualDoorsCount?: Maybe<Scalars['Int']>;
  updateVisualDoorsCount?: Maybe<Scalars['Int']>;
};

export enum LightPosition {
  Center = 'CENTER',
  Left_1 = 'LEFT_1',
  Left_2 = 'LEFT_2',
  Right_1 = 'RIGHT_1',
  Right_2 = 'RIGHT_2'
}

/** Provide location and intensity of light sources */
export type LightSourcesParameters = {
  __typename?: 'LightSourcesParameters';
  intensity: Scalars['Float'];
  location: Array<Scalars['Float']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String'];
  user: User;
};

export enum LogoPlacement {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type Maintenance = {
  __typename?: 'Maintenance';
  customers: Array<Customer>;
  description: Scalars['String'];
  id: Scalars['String'];
  title: Scalars['String'];
};

/**
 * This type represents any kind of monetary value, such as price or balance.
 * It is a combination of a `value` in cents, and a `currency` as an
 * [ISO 4217 Currency Code](https://www.xe.com/iso4217.php).
 *
 * ### Example
 *
 * A price of `1, 99 €` will be represented as
 *
 * ```
 * {
 *     value: 199,
 *     currency: "EUR"
 *   }
 * ```
 */
export type MonetaryValue = {
  __typename?: 'MonetaryValue';
  currency: Scalars['String'];
  value: Scalars['Int'];
};

export type MonetaryValueInput = {
  currency: Scalars['String'];
  value: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateExampleImageSetsForCustomer: Scalars['Boolean'];
  addTagToUserScenario: Scalars['Boolean'];
  addVisualDoorToShadowProfile: Scalars['Boolean'];
  assignMultipleVisualDoorsToProduct: Scalars['Boolean'];
  assignProductToVisualDoor: Scalars['Boolean'];
  changePassword: User;
  createCname: Scalars['Boolean'];
  createCustomer: Customer;
  createExampleImageSet: ExampleImageSet;
  createNewAppUser: AppUser;
  createNewExampleImage: ExampleImage;
  createNewUser: User;
  createOrUpdateShadowProfile: ShadowProfile;
  /**
   * Upload an image or use one of our example images to create a user scenario
   *  user scenario is only persisted for 4 days.
   */
  createUserScenario: CreateScenarioResponse;
  deactivateExampleImageSetsForCustomer: Scalars['Boolean'];
  deleteCustomAttribute: Scalars['Boolean'];
  deleteExampleImage: Scalars['Boolean'];
  deleteExampleImageSet: Scalars['Boolean'];
  deletePod: Scalars['String'];
  deleteProduct: Scalars['Boolean'];
  deleteShadowImage: Scalars['Boolean'];
  deleteShadowProfile: Scalars['Boolean'];
  deleteTagFromUserScenario: Scalars['Boolean'];
  deleteUser: Scalars['Boolean'];
  deleteUserScenarioForAppUser: Array<UserScenario>;
  deleteUsersScenario: Scalars['Boolean'];
  deleteVisualDoor: Scalars['Boolean'];
  duplicateExampleImagesForCustomer: Scalars['Boolean'];
  forgotPasswordRequest: Scalars['Boolean'];
  importExampleImages: Scalars['Boolean'];
  importProducts: Scalars['Boolean'];
  importVisualDoors: ImportResult;
  login: LoginResponse;
  markVisualDoorAsFavorite: AppUser;
  /** Performs an initial order population */
  populateProductOrder: Scalars['Boolean'];
  /** Performs an initial order population */
  populateVisualDoorOrder: Scalars['Boolean'];
  /** Refine the position of the corners of a user scenario */
  refineCorners: UserScenario;
  regenerateShadowInpainting: Scalars['Boolean'];
  removeVisualDoorFromShadowProfile: Scalars['Boolean'];
  /** Create or update a custom attribute */
  saveCustomAttribute: CustomAttribute;
  saveCustomerConfig: CustomerConfig;
  saveMaintenance: Maintenance;
  saveProduct: Product;
  saveVisualDoor: VisualDoor;
  setPassword: Scalars['Boolean'];
  startPod: Scalars['String'];
  stopPod: Scalars['String'];
  toggleVisualDoorFavorite: Scalars['Boolean'];
  trackEvent: Scalars['Boolean'];
  unMarkVisualDoorAsFavorite: AppUser;
  unassignAllVisualDoorsForProduct: Scalars['Boolean'];
  unassignProductFromVisualDoor: Scalars['Boolean'];
  updateCustomerActivation: Scalars['Boolean'];
  updateDefinedOrdersOfProducts: Scalars['Boolean'];
  updateExampleImage: ExampleImage;
  updateExampleImageOrder: Scalars['Boolean'];
  updateExampleImageSet: ExampleImageSet;
  updateOrderOfVisualDoors: Scalars['Boolean'];
  uploadConfigImage: Scalars['String'];
  uploadNewExampleImageImage: ExampleImage;
  /** Warms up the aws-lambdas to avoid cold starts on future requests */
  warmUpLambdas: Scalars['Boolean'];
};


export type MutationActivateExampleImageSetsForCustomerArgs = {
  customerKey: Scalars['String'];
};


export type MutationAddTagToUserScenarioArgs = {
  tag: Scalars['String'];
  userScenarioId: Scalars['String'];
};


export type MutationAddVisualDoorToShadowProfileArgs = {
  shadowProfileId: Scalars['Int'];
  visualDoorId: Scalars['String'];
};


export type MutationAssignMultipleVisualDoorsToProductArgs = {
  customerKey: Scalars['String'];
  productId: Scalars['String'];
  visualDoorExternalIds: Array<Scalars['String']>;
};


export type MutationAssignProductToVisualDoorArgs = {
  productId: Scalars['String'];
  visualDoorId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationCreateCnameArgs = {
  key: Scalars['String'];
};


export type MutationCreateCustomerArgs = {
  homepageUrl?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateExampleImageSetArgs = {
  customerKey: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateNewExampleImageArgs = {
  customerKey: Scalars['String'];
  doorType?: InputMaybe<DoorType>;
  file: Scalars['Upload'];
  setNumber?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateNewUserArgs = {
  customerKey?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  role: Role;
};


export type MutationCreateOrUpdateShadowProfileArgs = {
  customerKey: Scalars['String'];
  parameters: CreateOrUpdateShadowProfileInputArguments;
};


export type MutationCreateUserScenarioArgs = {
  parameters: CreateUserScenarioParameters;
};


export type MutationDeactivateExampleImageSetsForCustomerArgs = {
  customerKey: Scalars['String'];
};


export type MutationDeleteCustomAttributeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteExampleImageArgs = {
  id: Scalars['String'];
};


export type MutationDeleteExampleImageSetArgs = {
  id: Scalars['String'];
};


export type MutationDeletePodArgs = {
  podId: Scalars['String'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['String'];
};


export type MutationDeleteShadowImageArgs = {
  scenarioId: Scalars['String'];
};


export type MutationDeleteShadowProfileArgs = {
  shadowProfileId: Scalars['Int'];
};


export type MutationDeleteTagFromUserScenarioArgs = {
  tag: Scalars['String'];
  userScenarioId: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  uuid: Scalars['String'];
};


export type MutationDeleteUserScenarioForAppUserArgs = {
  userScenarioShortId: Scalars['String'];
};


export type MutationDeleteUsersScenarioArgs = {
  userScenarioId: Scalars['String'];
};


export type MutationDeleteVisualDoorArgs = {
  id: Scalars['String'];
};


export type MutationDuplicateExampleImagesForCustomerArgs = {
  destinationCustomerKey: Scalars['String'];
  destinationDoorType: DoorType;
  sourceCustomerKey: Scalars['String'];
  sourceDoorType: DoorType;
};


export type MutationForgotPasswordRequestArgs = {
  email: Scalars['String'];
};


export type MutationImportExampleImagesArgs = {
  customerKey: Scalars['String'];
  doorType: DoorType;
  file: Scalars['Upload'];
};


export type MutationImportProductsArgs = {
  customerKey: Scalars['String'];
  deleteAllExistingProducts?: InputMaybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
};


export type MutationImportVisualDoorsArgs = {
  customerKey: Scalars['String'];
  deleteAllExistingVisualDoors?: InputMaybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationMarkVisualDoorAsFavoriteArgs = {
  visualDoorId: Scalars['String'];
};


export type MutationPopulateProductOrderArgs = {
  customerKeys: Array<Scalars['String']>;
};


export type MutationPopulateVisualDoorOrderArgs = {
  customerKeys: Array<Scalars['String']>;
};


export type MutationRefineCornersArgs = {
  corners: Array<DoorCornersInput>;
  customData?: InputMaybe<Scalars['String']>;
  userScenarioId: Scalars['String'];
};


export type MutationRegenerateShadowInpaintingArgs = {
  scenarioId: Scalars['String'];
};


export type MutationRemoveVisualDoorFromShadowProfileArgs = {
  shadowProfileId: Scalars['Int'];
  visualDoorId: Scalars['String'];
};


export type MutationSaveCustomAttributeArgs = {
  customerKey: Scalars['String'];
  input: CustomAttributeSaveInput;
};


export type MutationSaveCustomerConfigArgs = {
  input: SaveCustomerConfigInput;
};


export type MutationSaveMaintenanceArgs = {
  customerKeys: Array<Scalars['String']>;
  description: Scalars['String'];
  title: Scalars['String'];
};


export type MutationSaveProductArgs = {
  input: SaveProductInput;
};


export type MutationSaveVisualDoorArgs = {
  customerKey: Scalars['String'];
  customerSpecificParameters?: InputMaybe<CustomerSpecificParameters>;
  parameters: CreateVisualDoorParameters;
  shadowProfileId?: InputMaybe<Scalars['Int']>;
};


export type MutationSetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationStartPodArgs = {
  podId: Scalars['String'];
};


export type MutationStopPodArgs = {
  podId: Scalars['String'];
};


export type MutationToggleVisualDoorFavoriteArgs = {
  visualDoorId: Scalars['String'];
};


export type MutationTrackEventArgs = {
  event: TrackEventInput;
};


export type MutationUnMarkVisualDoorAsFavoriteArgs = {
  visualDoorId: Scalars['String'];
};


export type MutationUnassignAllVisualDoorsForProductArgs = {
  productId: Scalars['String'];
};


export type MutationUnassignProductFromVisualDoorArgs = {
  productId: Scalars['String'];
  visualDoorId: Scalars['String'];
};


export type MutationUpdateCustomerActivationArgs = {
  active: Scalars['Boolean'];
  customerKey: Scalars['String'];
};


export type MutationUpdateDefinedOrdersOfProductsArgs = {
  productType: Scalars['String'];
  productsWithOrder: Array<ProductWithOrder>;
};


export type MutationUpdateExampleImageArgs = {
  corners: Array<DoorCornersInput>;
  customData?: InputMaybe<Scalars['String']>;
  doorType: DoorType;
  exampleImageId: Scalars['String'];
  lightPosition: LightPosition;
};


export type MutationUpdateExampleImageOrderArgs = {
  exampleImages: Array<ExampleImageOrderInput>;
};


export type MutationUpdateExampleImageSetArgs = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nr: Scalars['Int'];
};


export type MutationUpdateOrderOfVisualDoorsArgs = {
  customerKey?: InputMaybe<Scalars['String']>;
  visualDoorExternalIds: Scalars['String'];
};


export type MutationUploadConfigImageArgs = {
  configId: Scalars['String'];
  file: Scalars['Upload'];
  fileType: Scalars['String'];
};


export type MutationUploadNewExampleImageImageArgs = {
  exampleImageId: Scalars['String'];
  file: Scalars['Upload'];
  fileType: Scalars['String'];
};

/** PageInfo */
export type PageInfoModel = {
  __typename?: 'PageInfoModel';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalPages: Scalars['Int'];
  totalResults: Scalars['Int'];
};

export type PaginatedProducts = {
  __typename?: 'PaginatedProducts';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<Product>>;
};

export enum PaginationMode {
  Cursor = 'CURSOR',
  Page = 'PAGE'
}

export type PaginationModel = {
  afterCursor?: InputMaybe<Scalars['String']>;
  mode: PaginationMode;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type PasswordResetToken = {
  __typename?: 'PasswordResetToken';
  email: Scalars['String'];
  token: Scalars['String'];
};

/** The product interface with the common fields for all products */
export type Product = {
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']>;
  /** The uuid of the product */
  id: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  /** The human readable name of the visual door */
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  /** The type of the product */
  productType: Scalars['String'];
  /** Optional filter style on the rendering context of the canvas */
  renderingContextFillStyle?: Maybe<Scalars['String']>;
  /** Optional css filter on the rendering context of the canvas */
  renderingContextFilter?: Maybe<Scalars['String']>;
  showForAllDoors?: Maybe<Scalars['Boolean']>;
  showForDoorTypes?: Maybe<Array<DoorType>>;
  /** The thumbnail image of the visual door */
  thumbnailImage?: Maybe<Image>;
  visualDoors: Array<VisualDoor>;
  /** The full image of the visual door */
  visualisationImage: Image;
  /** 0 represents the door itself, negative numbers mean the product is visualised behind the door, positive numbers mean the product is visualised in front of the door */
  visualisationLayer?: Maybe<Scalars['Float']>;
};

export type ProductFilter = {
  customerKey?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Only deliver products for this product type */
  productType?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Only deliver products for this visual door */
  visualDoorId?: InputMaybe<Scalars['String']>;
};

export enum ProductLinkType {
  NewTab = 'NEW_TAB',
  PopUp = 'POP_UP',
  SameTab = 'SAME_TAB'
}

export type ProductWithOrder = {
  id: Scalars['String'];
  order: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  getAllCustomer: Array<Customer>;
  getAllShadowProfiles: Array<ShadowProfile>;
  getAllUserScenarios: UserScenarioPaginationModel;
  getAllUsers: Array<User>;
  getAppUser: AppUser;
  getCountsPerDay: Array<UserScenarioCountByDay>;
  /** Delivers the customer for the given key. */
  getCustomer: Customer;
  getDefaultCorners: DoorCorners;
  getEmailLogs: EmailLogPaginationModel;
  getEventCountsPerInterval: Array<EventsCountByDate>;
  getEvents: TrackingEventPaginationModel;
  getEventsCount: Scalars['Int'];
  /** Delivers the example image for the given exampleId */
  getExampleImage: ExampleImage;
  /** Delivers the example image for the given short id */
  getExampleImageByShortId: ExampleImage;
  getExampleImageSetByNumber: ExampleImageSet;
  getExampleImageSetsForCustomer: Array<ExampleImageSet>;
  /** Delivers example images for the customer if a user has no image at hand. */
  getExampleImages: ExampleImagesResponse;
  getFavoriteCount: Scalars['Float'];
  getMaintenance?: Maybe<Maintenance>;
  getPaginatedProducts: PaginatedProducts;
  getPasswordResetTokenInformation: PasswordResetToken;
  getProduct: Product;
  getProductByExternaldId?: Maybe<Product>;
  getShadowProfile: ShadowProfile;
  /** Delivers the user scenario for the given UUID */
  getUserScenario: UserScenario;
  /** Delivers the user scenario for the given short id */
  getUserScenarioByShortId: UserScenario;
  /** Get the visual door for the given uuid */
  getVisualDoor: VisualDoor;
  /** Get the visual door for a given customer and external id */
  getVisualDoorForExternalIdAndCustomer: VisualDoor;
  /** Delivers the visual doors provided by the customer. */
  getVisualDoors: VisualDoorPaginationModel;
  getVisualDoorsFilterOptions?: Maybe<VisualDoorFilterOptions>;
  getVisualDoorsPaginated: VisualDoorPaginationModel;
  healthCheck: Scalars['String'];
  listPods: Array<RunpodPod>;
  me: User;
};


export type QueryGetAllCustomerArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAllShadowProfilesArgs = {
  customerKey: Scalars['String'];
};


export type QueryGetAllUserScenariosArgs = {
  filter?: InputMaybe<UserScenariosFilter>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetCountsPerDayArgs = {
  customerKey: Scalars['String'];
  daysCount?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCustomerArgs = {
  customerKey: Scalars['String'];
};


export type QueryGetDefaultCornersArgs = {
  doorLocationEnd?: InputMaybe<Scalars['Float']>;
  doorLocationStart?: InputMaybe<Scalars['Float']>;
  doorType: DoorType;
  imageHeight: Scalars['Float'];
  imageWidth: Scalars['Float'];
};


export type QueryGetEmailLogsArgs = {
  filter?: InputMaybe<EmailLogFilter>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetEventCountsPerIntervalArgs = {
  arg: GetEventCountsPerIntervalInput;
};


export type QueryGetEventsArgs = {
  filter?: InputMaybe<EventFilterInput>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetEventsCountArgs = {
  filter?: InputMaybe<EventFilterInput>;
};


export type QueryGetExampleImageArgs = {
  exampleImageId: Scalars['String'];
};


export type QueryGetExampleImageByShortIdArgs = {
  shortId: Scalars['String'];
};


export type QueryGetExampleImageSetByNumberArgs = {
  customerKey: Scalars['String'];
  nr: Scalars['Int'];
};


export type QueryGetExampleImageSetsForCustomerArgs = {
  customerKey: Scalars['String'];
};


export type QueryGetExampleImagesArgs = {
  customerKey: Scalars['String'];
  doorType?: InputMaybe<DoorType>;
  setNumber?: InputMaybe<Scalars['Int']>;
};


export type QueryGetFavoriteCountArgs = {
  customerKey: Scalars['String'];
};


export type QueryGetPaginatedProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetPasswordResetTokenInformationArgs = {
  token: Scalars['String'];
};


export type QueryGetProductArgs = {
  id: Scalars['String'];
};


export type QueryGetProductByExternaldIdArgs = {
  customerKey: Scalars['String'];
  externalId: Scalars['String'];
};


export type QueryGetShadowProfileArgs = {
  shadowProfileId: Scalars['Float'];
};


export type QueryGetUserScenarioArgs = {
  id: Scalars['String'];
};


export type QueryGetUserScenarioByShortIdArgs = {
  shortId: Scalars['String'];
};


export type QueryGetVisualDoorArgs = {
  visualDoorId: Scalars['String'];
};


export type QueryGetVisualDoorForExternalIdAndCustomerArgs = {
  customerKey: Scalars['String'];
  externalId: Scalars['String'];
};


export type QueryGetVisualDoorsArgs = {
  customerKey: Scalars['String'];
  filter?: InputMaybe<FilterContextInput>;
  pagination?: InputMaybe<PaginationModel>;
};


export type QueryGetVisualDoorsFilterOptionsArgs = {
  filterInput?: InputMaybe<FilterContextInput>;
};


export type QueryGetVisualDoorsPaginatedArgs = {
  filter?: InputMaybe<VisualDoorsPaginationFilter>;
  pagination?: InputMaybe<PaginationModel>;
};

export enum Role {
  Admin = 'Admin',
  CustomerAdmin = 'CustomerAdmin'
}

export type RunpodPod = {
  __typename?: 'RunpodPod';
  costPerHr: Scalars['Float'];
  createdAt: Scalars['String'];
  desiredStatus: Scalars['String'];
  id: Scalars['String'];
  imageName: Scalars['String'];
  lastStartedAt: Scalars['String'];
  name: Scalars['String'];
  uptimeSeconds: Scalars['Int'];
};

export type SaveCustomerConfigInput = {
  allowClippedCorners?: InputMaybe<Scalars['Boolean']>;
  allowMultipleDoors?: InputMaybe<Scalars['Boolean']>;
  alwaysShowImageButtons?: InputMaybe<Scalars['Boolean']>;
  colors?: InputMaybe<ColorInput>;
  configUuid: Scalars['String'];
  defaultDoorType: DoorType;
  defaultLanguage: Scalars['String'];
  disableProductOrdering?: InputMaybe<Scalars['Boolean']>;
  disableVisualDoorsOrdering?: InputMaybe<Scalars['Boolean']>;
  enableDoorTypeDropdownSelection?: InputMaybe<Scalars['Boolean']>;
  enableShadowInpainting?: InputMaybe<Scalars['Boolean']>;
  enableVisualDoorsSearch?: InputMaybe<Scalars['Boolean']>;
  enabledProducts?: InputMaybe<Scalars['Boolean']>;
  enabledShadowProfiles: Scalars['Boolean'];
  gtmTag?: InputMaybe<Scalars['String']>;
  hideDownloadButton?: InputMaybe<Scalars['Boolean']>;
  hideFlipButton?: InputMaybe<Scalars['Boolean']>;
  hideRefineButtonUnderImage?: InputMaybe<Scalars['Boolean']>;
  hideShareButton?: InputMaybe<Scalars['Boolean']>;
  homepageUrl?: InputMaybe<Scalars['String']>;
  imageButtonsArrangement: ImageButtonsArrangement;
  imageButtonsPlacement: ImageButtonsPlacement;
  logoPlacement: LogoPlacement;
  logoSvg?: InputMaybe<Scalars['String']>;
  mainDoorTypeFilter?: InputMaybe<Array<DoorType>>;
  productLinkType: ProductLinkType;
  shopLinkOverwrite?: InputMaybe<Scalars['String']>;
  showCustomAttributesFilter?: InputMaybe<Scalars['Boolean']>;
  showDoorVisionBranding: Scalars['Boolean'];
  showGlassLayerInVisualization: Scalars['Boolean'];
  showRefineLayoutAfterUpload: Scalars['Boolean'];
  showUserScenarioGraphsInOverview: Scalars['Boolean'];
  showUserScenariosCounts: Scalars['Boolean'];
  showVisitHomepageButton?: InputMaybe<Scalars['Boolean']>;
  supportedDoorTypes: Array<DoorType>;
  supportedProductTypes?: InputMaybe<Array<Scalars['String']>>;
  translations?: InputMaybe<Scalars['String']>;
  useFavoritesList: Scalars['Boolean'];
};

export type SaveProductInput = {
  customData?: InputMaybe<Scalars['String']>;
  customerKey: Scalars['String'];
  enabled: Scalars['Boolean'];
  externalIds: Array<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order: Scalars['Float'];
  price?: InputMaybe<MonetaryValueInput>;
  productType: Scalars['String'];
  renderingContextFillStyle?: InputMaybe<Scalars['String']>;
  renderingContextFilter?: InputMaybe<Scalars['String']>;
  showForAllDoors?: InputMaybe<Scalars['Boolean']>;
  showForDoorTypes?: InputMaybe<Array<DoorType>>;
  thumbnailImage?: InputMaybe<Scalars['Upload']>;
  visualisationImage?: InputMaybe<Scalars['Upload']>;
  visualisationLayer?: InputMaybe<Scalars['Int']>;
};

export enum ScenarioType {
  Example = 'EXAMPLE',
  User = 'USER'
}

/** Represents the filters the user selected */
export type SelectedFilteCategoryOptions = {
  /** The filter category id */
  categoryId: Scalars['String'];
  /** The array of filter option ids the user selected for this filter category */
  selectedOptionIds: Array<Scalars['String']>;
};

export type ShadowImagesInput = {
  /** File upload if the user uses an own photo */
  image?: InputMaybe<Scalars['Upload']>;
  lightPosition: Scalars['String'];
};

export type ShadowProfile = {
  __typename?: 'ShadowProfile';
  customer: Customer;
  eastShadowImage?: Maybe<Image>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  northEastShadowImage?: Maybe<Image>;
  northShadowImage?: Maybe<Image>;
  northWestShadowImage?: Maybe<Image>;
  title: Scalars['String'];
  visualDoors: Array<VisualDoor>;
  visualDoorsCount: Scalars['Float'];
  westShadowImage?: Maybe<Image>;
};

export type TrackEventInput = {
  appUserShortId?: InputMaybe<Scalars['String']>;
  customerKey?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  exampleScenarioId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  productExternalId?: InputMaybe<Scalars['String']>;
  scenarioId?: InputMaybe<Scalars['String']>;
  scenarioType?: InputMaybe<ScenarioType>;
};

export type TrackingEvent = {
  __typename?: 'TrackingEvent';
  customer?: Maybe<Customer>;
  id: Scalars['String'];
  name: Scalars['String'];
  trackedAt: Scalars['DateTime'];
};

export type TrackingEventPaginationModel = {
  __typename?: 'TrackingEventPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<TrackingEvent>>;
};

export type User = {
  __typename?: 'User';
  customer?: Maybe<Customer>;
  email: Scalars['String'];
  id: Scalars['String'];
  lastLoggedInAt?: Maybe<Scalars['DateTime']>;
  role: Role;
};

/** A User scenario represents an uploaded and analysed image from the user */
export type UserScenario = {
  __typename?: 'UserScenario';
  /** The corners of the door in the image. Can be update with the mutation `refineCorners` */
  corners: Array<DoorCorners>;
  /** The original corners of the door in the image detected by our image analyser */
  cornersOriginal?: Maybe<Array<DoorCorners>>;
  createdAt: Scalars['DateTime'];
  customData?: Maybe<Scalars['String']>;
  customer: Customer;
  /** The debug information for this user scenario */
  debugInformation?: Maybe<Array<UserScenarioDebugInformation>>;
  /** The detected door type for this user scenario */
  doorType: DoorType;
  /** Determines if the user scenario was created by using an example image */
  exampleImageUsed: Scalars['Boolean'];
  /** The uuid of this user scenario */
  id: Scalars['String'];
  /**
   * The actual image of this user scenario.
   * This can ether be an uploaded image or one of our example images.
   */
  image: Image;
  isWaitingForVisualizationImprovement?: Maybe<Scalars['Boolean']>;
  /** The position of the light in the user image */
  lightPosition: LightPosition;
  /** Location and intensity of light sources */
  lightSourceParameters: Array<LightSourcesParameters>;
  nextUserScenario?: Maybe<UserScenario>;
  /** The orientation of the user scenario image */
  orientation: ImageOrientation;
  previousUserScenario?: Maybe<UserScenario>;
  /** The shadow image of the user scenario */
  shadowImage?: Maybe<Image>;
  /** The shortId of this user scenario */
  shortId: Scalars['String'];
  /** The tags for this user scenario */
  tags: Array<Scalars['String']>;
  thumbnailImage: Image;
};

export type UserScenarioCountByDay = {
  __typename?: 'UserScenarioCountByDay';
  all: Scalars['Float'];
  countExampleImages: Scalars['Float'];
  countUploads: Scalars['Float'];
  date: Scalars['DateTime'];
};

/** The debug information for the user scenario */
export type UserScenarioDebugInformation = {
  __typename?: 'UserScenarioDebugInformation';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  value: Scalars['String'];
};

export type UserScenarioPaginationModel = {
  __typename?: 'UserScenarioPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<UserScenario>>;
};

export type UserScenariosFilter = {
  customerKey?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  /** Show only user scenarios where image analyse delivered an error */
  hasError?: InputMaybe<Scalars['Boolean']>;
  /** Show only user scenarios where the user actually uploaded an image */
  onlyUploadedImages?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

/** A visual door is a door model provided by the customer */
export type VisualDoor = {
  __typename?: 'VisualDoor';
  customAttributes?: Maybe<Array<CustomAttributeValue>>;
  /** JSON.stringify data for the visual door custom to the provider of the visual door */
  customData?: Maybe<Scalars['String']>;
  directDoorsProperties?: Maybe<DirectDoorsVisualDoorParameters>;
  /** The type of the visual door */
  doorType: DoorType;
  /** Determines if the visual doors is enabled in the visualisation */
  enabled: Scalars['Boolean'];
  /** The external ids in the customers system */
  externalIds: Array<Scalars['String']>;
  /** Delivers the shadow image for the given lighting position */
  getShadowImage?: Maybe<Image>;
  /** The uuid of the visual door */
  id: Scalars['String'];
  /** The full image of the visual door */
  image: Image;
  isFavorite: Scalars['Boolean'];
  /** The human readable name of the visual door */
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  /** The price of this door */
  price?: Maybe<MonetaryValue>;
  shadowProfile?: Maybe<ShadowProfile>;
  /** The link which should be opened when the user clicks shop now */
  showNowLink: Scalars['String'];
  /** The human readable slug of the visual door */
  slug: Scalars['String'];
  /** A small thumbnail image which should be used to preview the visual door in lists etc. */
  thumbnail: Image;
};


/** A visual door is a door model provided by the customer */
export type VisualDoorGetShadowImageArgs = {
  lightPosition: LightPosition;
};

/** A filter category with the options */
export type VisualDoorFilterCategory = {
  __typename?: 'VisualDoorFilterCategory';
  /** The description of the filter category */
  description?: Maybe<Scalars['String']>;
  /** Defines if this filter category should be enabled */
  enabled: Scalars['Boolean'];
  /** The id of the filter category */
  id: Scalars['String'];
  /** The name of the filter category */
  name: Scalars['String'];
  /** The possible options which can be selected for this category */
  options: Array<VisualDoorFilterCategoryOption>;
};

/** A filter category with the options */
export type VisualDoorFilterCategoryOption = {
  __typename?: 'VisualDoorFilterCategoryOption';
  /** The count of visual doors which are including in this filter category option */
  count?: Maybe<Scalars['Float']>;
  /** The name of the category filter option which can be selected. */
  description: Scalars['String'];
  /** The id of the category options */
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
};

/** The filter options for the visual door */
export type VisualDoorFilterOptions = {
  __typename?: 'VisualDoorFilterOptions';
  /** The possible categories which can be used to filter the visual doors */
  categories?: Maybe<Array<VisualDoorFilterCategory>>;
  doorTypeOptions?: Maybe<Array<DoorTypeFilterOption>>;
  heroFilterOptions?: Maybe<Array<HeroFilterOption>>;
  /** Defines if the door type filters should be shown as a dropdown option */
  showDoorTypeFilterAsDropdown?: Maybe<Scalars['Boolean']>;
  /** The possible sorting options */
  sortingOptions?: Maybe<Array<VisualDoorSortingOption>>;
};

export type VisualDoorPaginationModel = {
  __typename?: 'VisualDoorPaginationModel';
  cursorBasedPaginationInfo?: Maybe<CursorBasedPageInfoModel>;
  pageInfo?: Maybe<PageInfoModel>;
  paginationMode: PaginationMode;
  results?: Maybe<Array<VisualDoor>>;
};

export enum VisualDoorProvider {
  Internal = 'INTERNAL',
  Shopify = 'SHOPIFY',
  Shopware = 'SHOPWARE'
}

/** A filter category with the options */
export type VisualDoorSortingOption = {
  __typename?: 'VisualDoorSortingOption';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type VisualDoorsPaginationFilter = {
  customerKey?: InputMaybe<Scalars['String']>;
  doorType?: InputMaybe<DoorType>;
  enabled: Scalars['Boolean'];
  onlyWithoutShadowProfile?: InputMaybe<Scalars['Boolean']>;
  priceFrom?: InputMaybe<Scalars['Float']>;
  priceTo?: InputMaybe<Scalars['Float']>;
  /** Search term can include the visual door name or external id */
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type GetMaintenanceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintenanceQuery = { __typename?: 'Query', getMaintenance?: { __typename?: 'Maintenance', title: string, description: string, customers: Array<{ __typename?: 'Customer', id: string, name: string, key: string }> } | null };

export type TrackEventMutationVariables = Exact<{
  name: Scalars['String'];
  customerKey?: InputMaybe<Scalars['String']>;
  scenarioType?: InputMaybe<ScenarioType>;
  appUserShortId?: InputMaybe<Scalars['String']>;
  scenarioId?: InputMaybe<Scalars['String']>;
  exampleScenarioId?: InputMaybe<Scalars['String']>;
  productExternalId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
}>;


export type TrackEventMutation = { __typename?: 'Mutation', trackEvent: boolean };

export type GetCustomerConfigQueryVariables = Exact<{
  customerKey: Scalars['String'];
}>;


export type GetCustomerConfigQuery = { __typename?: 'Query', getCustomer: { __typename?: 'Customer', name: string, homepageUrl?: string | null, isInMaintenance?: boolean | null, config: { __typename?: 'CustomerConfig', logoPath?: string | null, defaultLanguage: string, translationsPath: string, useFavoritesList: boolean, showDoorVisionBranding: boolean, showRefineLayoutAfterUpload: boolean, productLinkType: ProductLinkType, enabledShadowProfiles: boolean, showGlassLayerInVisualization: boolean, shopLinkOverwrite?: string | null, mainDoorTypeFilter?: Array<DoorType> | null, gtmTag?: string | null, enabledExampleImageSets?: boolean | null, defaultDoorType: DoorType, supportedDoorTypes: Array<DoorType>, allowMultipleDoors?: boolean | null, allowClippedCorners?: boolean | null, supportedProductTypes?: Array<string> | null, enableShadowInpainting?: boolean | null, enabledProducts?: boolean | null, hideShareButton?: boolean | null, enableDoorTypeDropdownSelection?: boolean | null, showCustomAttributesFilter?: boolean | null, hideDownloadButton?: boolean | null, hideFlipButton?: boolean | null, hideRefineButtonUnderImage?: boolean | null, showVisitHomepageButton?: boolean | null, alwaysShowImageButtons?: boolean | null, logoPlacement: LogoPlacement, imageButtonsArrangement: ImageButtonsArrangement, imageButtonsPlacement: ImageButtonsPlacement, enableVisualDoorsSearch?: boolean | null, colors?: { __typename?: 'CustomerColor', primary?: string | null, primaryText?: string | null, uploadPanelText?: string | null, uploadPanelBackground?: string | null, imageButtonsBackground?: string | null, imageButtonsText?: string | null } | null } } };

export type DoorFragment = { __typename?: 'VisualDoor', id: string, externalIds: Array<string>, doorType: DoorType, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } };

export type DoorWithShadowProfilesFragment = { __typename?: 'VisualDoor', id: string, externalIds: Array<string>, doorType: DoorType, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, shadowProfile?: { __typename?: 'ShadowProfile', id: number, northShadowImage?: { __typename?: 'Image', id: string, url: string } | null, westShadowImage?: { __typename?: 'Image', id: string, url: string } | null, eastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northEastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northWestShadowImage?: { __typename?: 'Image', id: string, url: string } | null } | null, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } };

export type GetVisualDoorsStateServiceQueryVariables = Exact<{
  customerKey: Scalars['String'];
  filter?: InputMaybe<FilterContextInput>;
  paginationModel?: InputMaybe<PaginationModel>;
}>;


export type GetVisualDoorsStateServiceQuery = { __typename?: 'Query', getVisualDoors: { __typename?: 'VisualDoorPaginationModel', paginationMode: PaginationMode, cursorBasedPaginationInfo?: { __typename?: 'CursorBasedPageInfoModel', hasNextPage: boolean, hasPreviousPage?: boolean | null, startCursor?: string | null, endCursor?: string | null } | null, pageInfo?: { __typename?: 'PageInfoModel', page: number, pageSize: number, totalResults: number, totalPages: number } | null, results?: Array<{ __typename?: 'VisualDoor', id: string, externalIds: Array<string>, doorType: DoorType, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } }> | null } };

export type GetVisualDoorQueryVariables = Exact<{
  customerKey: Scalars['String'];
  externalId: Scalars['String'];
}>;


export type GetVisualDoorQuery = { __typename?: 'Query', getVisualDoorForExternalIdAndCustomer: { __typename?: 'VisualDoor', id: string, externalIds: Array<string>, doorType: DoorType, name: string, customData?: string | null, showNowLink: string, slug: string, isFavorite: boolean, shadowProfile?: { __typename?: 'ShadowProfile', id: number, northShadowImage?: { __typename?: 'Image', id: string, url: string } | null, westShadowImage?: { __typename?: 'Image', id: string, url: string } | null, eastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northEastShadowImage?: { __typename?: 'Image', id: string, url: string } | null, northWestShadowImage?: { __typename?: 'Image', id: string, url: string } | null } | null, price?: { __typename?: 'MonetaryValue', currency: string, value: number } | null, thumbnail: { __typename?: 'Image', url: string }, image: { __typename?: 'Image', url: string } } };

export type CountFavoritesQueryVariables = Exact<{
  customerKey: Scalars['String'];
}>;


export type CountFavoritesQuery = { __typename?: 'Query', getFavoriteCount: number };

export type ToggleVisualDoorFavoriteMutationVariables = Exact<{
  visualDoorId: Scalars['String'];
}>;


export type ToggleVisualDoorFavoriteMutation = { __typename?: 'Mutation', toggleVisualDoorFavorite: boolean };

export type GetVisualDoorsFilterOptionsQueryVariables = Exact<{
  filter?: InputMaybe<FilterContextInput>;
}>;


export type GetVisualDoorsFilterOptionsQuery = { __typename?: 'Query', getVisualDoorsFilterOptions?: { __typename?: 'VisualDoorFilterOptions', heroFilterOptions?: Array<{ __typename?: 'HeroFilterOption', imageUrl: string, title: string, description?: string | null, categoryOptionsToSelect?: Array<{ __typename?: 'CategoryOptionsToSelect', categoryId: string, selectAllOptions?: boolean | null, optionsToSelect?: Array<string> | null }> | null }> | null, doorTypeOptions?: Array<{ __typename?: 'DoorTypeFilterOption', doorType: DoorType, description: string, svgImageUrl?: string | null }> | null, sortingOptions?: Array<{ __typename?: 'VisualDoorSortingOption', id: string, name: string }> | null, categories?: Array<{ __typename?: 'VisualDoorFilterCategory', id: string, name: string, enabled: boolean, description?: string | null, options: Array<{ __typename?: 'VisualDoorFilterCategoryOption', id: string, description: string, count?: number | null, imageUrl?: string | null }> }> | null } | null };

export type GetProductQueryVariables = Exact<{
  externalId: Scalars['String'];
  customerKey: Scalars['String'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProductByExternaldId?: { __typename: 'BasicProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null } | { __typename: 'FrameProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, width?: number | null, height?: number | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null } | null };

export type FrameProductFragment = { __typename?: 'FrameProduct', width?: number | null, height?: number | null };

type Product_BasicProduct_Fragment = { __typename: 'BasicProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null };

type Product_FrameProduct_Fragment = { __typename: 'FrameProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, width?: number | null, height?: number | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null };

export type ProductFragment = Product_BasicProduct_Fragment | Product_FrameProduct_Fragment;

export type GetPaginatedProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<PaginationModel>;
}>;


export type GetPaginatedProductsQuery = { __typename?: 'Query', getPaginatedProducts: { __typename: 'PaginatedProducts', cursorBasedPaginationInfo?: { __typename?: 'CursorBasedPageInfoModel', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage?: boolean | null } | null, results?: Array<{ __typename: 'BasicProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null } | { __typename: 'FrameProduct', id: string, externalIds: Array<string>, name: string, link?: string | null, enabled: boolean, customData?: string | null, productType: string, visualisationLayer?: number | null, renderingContextFilter?: string | null, renderingContextFillStyle?: string | null, width?: number | null, height?: number | null, price?: { __typename?: 'MonetaryValue', value: number, currency: string } | null, visualisationImage: { __typename?: 'Image', id: string, url: string }, thumbnailImage?: { __typename?: 'Image', id: string, url: string } | null }> | null } };

export type GetUserScenariosForAppUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserScenariosForAppUserQuery = { __typename?: 'Query', getAppUser: { __typename?: 'AppUser', id: string, getUserScenarios: Array<{ __typename?: 'UserScenario', id: string, shortId: string, doorType: DoorType, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } }> } };

export type DeleteUserScenarioForAppUserMutationVariables = Exact<{
  userScenarioId: Scalars['String'];
}>;


export type DeleteUserScenarioForAppUserMutation = { __typename?: 'Mutation', deleteUserScenarioForAppUser: Array<{ __typename?: 'UserScenario', id: string, shortId: string, doorType: DoorType, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } }> };

export type GetExampleImagesQueryVariables = Exact<{
  customerKey: Scalars['String'];
  doorType: DoorType;
  setNumber?: InputMaybe<Scalars['Int']>;
}>;


export type GetExampleImagesQuery = { __typename?: 'Query', getExampleImages: { __typename?: 'ExampleImagesResponse', verticals: Array<{ __typename?: 'ExampleImage', id: string, shortId: string, lightPosition: LightPosition, doorType: DoorType, customData?: string | null, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, image: { __typename?: 'Image', id: string, url: string }, thumbnail: { __typename?: 'Image', id: string, url: string } }>, horizontals: Array<{ __typename?: 'ExampleImage', id: string, shortId: string, lightPosition: LightPosition, doorType: DoorType, customData?: string | null, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, image: { __typename?: 'Image', id: string, url: string }, thumbnail: { __typename?: 'Image', id: string, url: string } }> } };

export type ExampleScenarioFragment = { __typename?: 'ExampleImage', id: string, shortId: string, lightPosition: LightPosition, doorType: DoorType, customData?: string | null, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, image: { __typename?: 'Image', id: string, url: string }, thumbnail: { __typename?: 'Image', id: string, url: string } };

export type GetDefaultCornersQueryVariables = Exact<{
  doorLocationStart?: InputMaybe<Scalars['Float']>;
  doorLocationEnd?: InputMaybe<Scalars['Float']>;
  imageWidth: Scalars['Float'];
  imageHeight: Scalars['Float'];
  doorType: DoorType;
}>;


export type GetDefaultCornersQuery = { __typename?: 'Query', getDefaultCorners: { __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } } };

export type UpdateCornersMutationVariables = Exact<{
  userScenarioId: Scalars['String'];
  corners: Array<DoorCornersInput> | DoorCornersInput;
  customData?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCornersMutation = { __typename?: 'Mutation', refineCorners: { __typename?: 'UserScenario', id: string, shortId: string, doorType: DoorType, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } } };

export type CreateUserScenarioFromUploadMutationVariables = Exact<{
  createUserScenarioParameters: CreateUserScenarioParameters;
}>;


export type CreateUserScenarioFromUploadMutation = { __typename?: 'Mutation', createUserScenario: { __typename?: 'CreateScenarioResponse', showCornerRefinement: boolean, userScenario: { __typename?: 'UserScenario', id: string, shortId: string, doorType: DoorType, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } } } };

export type GetUserScenarioByShortIdQueryVariables = Exact<{
  shortId: Scalars['String'];
}>;


export type GetUserScenarioByShortIdQuery = { __typename?: 'Query', getUserScenarioByShortId: { __typename?: 'UserScenario', id: string, shortId: string, doorType: DoorType, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } } };

export type UserScenarioFragment = { __typename?: 'UserScenario', id: string, shortId: string, doorType: DoorType, customData?: string | null, lightPosition: LightPosition, isWaitingForVisualizationImprovement?: boolean | null, corners: Array<{ __typename?: 'DoorCorners', index: number, doorType: DoorType, topLeft: { __typename?: 'CornerPosition', x: number, y: number }, topRight: { __typename?: 'CornerPosition', x: number, y: number }, bottomLeft: { __typename?: 'CornerPosition', x: number, y: number }, bottomRight: { __typename?: 'CornerPosition', x: number, y: number } }>, lightSourceParameters: Array<{ __typename?: 'LightSourcesParameters', intensity: number, location: Array<number> }>, shadowImage?: { __typename?: 'Image', id: string, url: string } | null, image: { __typename?: 'Image', id: string, url: string }, thumbnailImage: { __typename?: 'Image', id: string, url: string } };

export type CreateNewAppUserMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateNewAppUserMutation = { __typename?: 'Mutation', createNewAppUser: { __typename?: 'AppUser', id: string } };

export type GetUserQueryVariables = Exact<{
  customerKey: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', getCustomer: { __typename?: 'Customer', name: string, config: { __typename?: 'CustomerConfig', logoPath?: string | null, defaultLanguage: string, translationsPath: string, useFavoritesList: boolean, showDoorVisionBranding: boolean } } };

export const DoorFragmentDoc = gql`
    fragment Door on VisualDoor {
  id
  externalIds
  doorType
  name
  customData
  price {
    currency
    value
  }
  showNowLink
  slug
  thumbnail {
    url
  }
  image {
    url
  }
  isFavorite
}
    `;
export const DoorWithShadowProfilesFragmentDoc = gql`
    fragment DoorWithShadowProfiles on VisualDoor {
  id
  externalIds
  doorType
  name
  customData
  shadowProfile {
    id
    northShadowImage {
      id
      url
    }
    westShadowImage {
      id
      url
    }
    eastShadowImage {
      id
      url
    }
    northEastShadowImage {
      id
      url
    }
    northWestShadowImage {
      id
      url
    }
  }
  price {
    currency
    value
  }
  showNowLink
  slug
  thumbnail {
    url
  }
  image {
    url
  }
  isFavorite
}
    `;
export const FrameProductFragmentDoc = gql`
    fragment FrameProduct on FrameProduct {
  width
  height
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  __typename
  id
  externalIds
  name
  price {
    value
    currency
  }
  link
  enabled
  customData
  productType
  visualisationLayer
  renderingContextFilter
  renderingContextFillStyle
  visualisationImage {
    id
    url
  }
  thumbnailImage {
    id
    url
  }
  ... on FrameProduct {
    ...FrameProduct
  }
}
    ${FrameProductFragmentDoc}`;
export const ExampleScenarioFragmentDoc = gql`
    fragment ExampleScenario on ExampleImage {
  id
  shortId
  lightPosition
  doorType
  customData
  shadowImage {
    id
    url
  }
  corners {
    index
    doorType
    topLeft {
      x
      y
    }
    topRight {
      x
      y
    }
    bottomLeft {
      x
      y
    }
    bottomRight {
      x
      y
    }
  }
  lightSourceParameters {
    intensity
    location
  }
  image {
    id
    url
  }
  thumbnail {
    id
    url
  }
}
    `;
export const UserScenarioFragmentDoc = gql`
    fragment UserScenario on UserScenario {
  id
  shortId
  doorType
  customData
  lightPosition
  isWaitingForVisualizationImprovement
  corners {
    index
    doorType
    topLeft {
      x
      y
    }
    topRight {
      x
      y
    }
    bottomLeft {
      x
      y
    }
    bottomRight {
      x
      y
    }
  }
  lightSourceParameters {
    intensity
    location
  }
  shadowImage {
    id
    url
  }
  image {
    id
    url
  }
  thumbnailImage {
    id
    url
  }
}
    `;
export const GetMaintenanceDocument = gql`
    query GetMaintenance {
  getMaintenance {
    title
    description
    customers {
      id
      name
      key
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaintenanceGQL extends Apollo.Query<GetMaintenanceQuery, GetMaintenanceQueryVariables> {
    override document = GetMaintenanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TrackEventDocument = gql`
    mutation TrackEvent($name: String!, $customerKey: String, $scenarioType: ScenarioType, $appUserShortId: String, $scenarioId: String, $exampleScenarioId: String, $productExternalId: String, $data: String) {
  trackEvent(
    event: {name: $name, customerKey: $customerKey, appUserShortId: $appUserShortId, scenarioId: $scenarioId, scenarioType: $scenarioType, exampleScenarioId: $exampleScenarioId, productExternalId: $productExternalId, data: $data}
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TrackEventGQL extends Apollo.Mutation<TrackEventMutation, TrackEventMutationVariables> {
    override document = TrackEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCustomerConfigDocument = gql`
    query GetCustomerConfig($customerKey: String!) {
  getCustomer(customerKey: $customerKey) {
    name
    homepageUrl
    isInMaintenance
    config {
      logoPath
      defaultLanguage
      translationsPath
      useFavoritesList
      showDoorVisionBranding
      showRefineLayoutAfterUpload
      productLinkType
      enabledShadowProfiles
      showGlassLayerInVisualization
      shopLinkOverwrite
      mainDoorTypeFilter
      gtmTag
      enabledExampleImageSets
      defaultDoorType
      supportedDoorTypes
      allowMultipleDoors
      allowClippedCorners
      supportedProductTypes
      enableShadowInpainting
      enabledProducts
      hideShareButton
      enableDoorTypeDropdownSelection
      showCustomAttributesFilter
      hideDownloadButton
      hideFlipButton
      hideRefineButtonUnderImage
      showVisitHomepageButton
      alwaysShowImageButtons
      logoPlacement
      imageButtonsArrangement
      imageButtonsPlacement
      enableVisualDoorsSearch
      colors {
        primary
        primaryText
        uploadPanelText
        uploadPanelBackground
        imageButtonsBackground
        imageButtonsText
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCustomerConfigGQL extends Apollo.Query<GetCustomerConfigQuery, GetCustomerConfigQueryVariables> {
    override document = GetCustomerConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisualDoorsStateServiceDocument = gql`
    query GetVisualDoorsStateService($customerKey: String!, $filter: FilterContextInput, $paginationModel: PaginationModel) {
  getVisualDoors(
    customerKey: $customerKey
    filter: $filter
    pagination: $paginationModel
  ) {
    paginationMode
    cursorBasedPaginationInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    pageInfo {
      page
      pageSize
      totalResults
      totalPages
    }
    results {
      ...Door
    }
  }
}
    ${DoorFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisualDoorsStateServiceGQL extends Apollo.Query<GetVisualDoorsStateServiceQuery, GetVisualDoorsStateServiceQueryVariables> {
    override document = GetVisualDoorsStateServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisualDoorDocument = gql`
    query GetVisualDoor($customerKey: String!, $externalId: String!) {
  getVisualDoorForExternalIdAndCustomer(
    customerKey: $customerKey
    externalId: $externalId
  ) {
    ...DoorWithShadowProfiles
  }
}
    ${DoorWithShadowProfilesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisualDoorGQL extends Apollo.Query<GetVisualDoorQuery, GetVisualDoorQueryVariables> {
    override document = GetVisualDoorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountFavoritesDocument = gql`
    query countFavorites($customerKey: String!) {
  getFavoriteCount(customerKey: $customerKey)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountFavoritesGQL extends Apollo.Query<CountFavoritesQuery, CountFavoritesQueryVariables> {
    override document = CountFavoritesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleVisualDoorFavoriteDocument = gql`
    mutation toggleVisualDoorFavorite($visualDoorId: String!) {
  toggleVisualDoorFavorite(visualDoorId: $visualDoorId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleVisualDoorFavoriteGQL extends Apollo.Mutation<ToggleVisualDoorFavoriteMutation, ToggleVisualDoorFavoriteMutationVariables> {
    override document = ToggleVisualDoorFavoriteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVisualDoorsFilterOptionsDocument = gql`
    query GetVisualDoorsFilterOptions($filter: FilterContextInput) {
  getVisualDoorsFilterOptions(filterInput: $filter) {
    heroFilterOptions {
      imageUrl
      title
      description
      categoryOptionsToSelect {
        categoryId
        selectAllOptions
        optionsToSelect
      }
    }
    doorTypeOptions {
      doorType
      description
      svgImageUrl
    }
    sortingOptions {
      id
      name
    }
    categories {
      id
      name
      enabled
      description
      options {
        id
        description
        count
        imageUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVisualDoorsFilterOptionsGQL extends Apollo.Query<GetVisualDoorsFilterOptionsQuery, GetVisualDoorsFilterOptionsQueryVariables> {
    override document = GetVisualDoorsFilterOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProductDocument = gql`
    query GetProduct($externalId: String!, $customerKey: String!) {
  getProductByExternaldId(externalId: $externalId, customerKey: $customerKey) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProductGQL extends Apollo.Query<GetProductQuery, GetProductQueryVariables> {
    override document = GetProductDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPaginatedProductsDocument = gql`
    query GetPaginatedProducts($filter: ProductFilter, $pagination: PaginationModel) {
  getPaginatedProducts(filter: $filter, pagination: $pagination) {
    __typename
    cursorBasedPaginationInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    results {
      ...Product
    }
  }
}
    ${ProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaginatedProductsGQL extends Apollo.Query<GetPaginatedProductsQuery, GetPaginatedProductsQueryVariables> {
    override document = GetPaginatedProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserScenariosForAppUserDocument = gql`
    query GetUserScenariosForAppUser {
  getAppUser {
    id
    getUserScenarios {
      ...UserScenario
    }
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserScenariosForAppUserGQL extends Apollo.Query<GetUserScenariosForAppUserQuery, GetUserScenariosForAppUserQueryVariables> {
    override document = GetUserScenariosForAppUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserScenarioForAppUserDocument = gql`
    mutation DeleteUserScenarioForAppUser($userScenarioId: String!) {
  deleteUserScenarioForAppUser(userScenarioShortId: $userScenarioId) {
    ...UserScenario
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserScenarioForAppUserGQL extends Apollo.Mutation<DeleteUserScenarioForAppUserMutation, DeleteUserScenarioForAppUserMutationVariables> {
    override document = DeleteUserScenarioForAppUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExampleImagesDocument = gql`
    query GetExampleImages($customerKey: String!, $doorType: DoorType!, $setNumber: Int) {
  getExampleImages(
    customerKey: $customerKey
    doorType: $doorType
    setNumber: $setNumber
  ) {
    verticals {
      ...ExampleScenario
    }
    horizontals {
      ...ExampleScenario
    }
  }
}
    ${ExampleScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExampleImagesGQL extends Apollo.Query<GetExampleImagesQuery, GetExampleImagesQueryVariables> {
    override document = GetExampleImagesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultCornersDocument = gql`
    query GetDefaultCorners($doorLocationStart: Float, $doorLocationEnd: Float, $imageWidth: Float!, $imageHeight: Float!, $doorType: DoorType!) {
  getDefaultCorners(
    doorLocationStart: $doorLocationStart
    doorLocationEnd: $doorLocationEnd
    imageWidth: $imageWidth
    imageHeight: $imageHeight
    doorType: $doorType
  ) {
    index
    doorType
    topLeft {
      x
      y
    }
    topRight {
      x
      y
    }
    bottomLeft {
      x
      y
    }
    bottomRight {
      x
      y
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultCornersGQL extends Apollo.Query<GetDefaultCornersQuery, GetDefaultCornersQueryVariables> {
    override document = GetDefaultCornersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCornersDocument = gql`
    mutation UpdateCorners($userScenarioId: String!, $corners: [DoorCornersInput!]!, $customData: String) {
  refineCorners(
    userScenarioId: $userScenarioId
    corners: $corners
    customData: $customData
  ) {
    ...UserScenario
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCornersGQL extends Apollo.Mutation<UpdateCornersMutation, UpdateCornersMutationVariables> {
    override document = UpdateCornersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserScenarioFromUploadDocument = gql`
    mutation CreateUserScenarioFromUpload($createUserScenarioParameters: CreateUserScenarioParameters!) {
  createUserScenario(parameters: $createUserScenarioParameters) {
    showCornerRefinement
    userScenario {
      ...UserScenario
    }
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserScenarioFromUploadGQL extends Apollo.Mutation<CreateUserScenarioFromUploadMutation, CreateUserScenarioFromUploadMutationVariables> {
    override document = CreateUserScenarioFromUploadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserScenarioByShortIdDocument = gql`
    query GetUserScenarioByShortId($shortId: String!) {
  getUserScenarioByShortId(shortId: $shortId) {
    ...UserScenario
  }
}
    ${UserScenarioFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserScenarioByShortIdGQL extends Apollo.Query<GetUserScenarioByShortIdQuery, GetUserScenarioByShortIdQueryVariables> {
    override document = GetUserScenarioByShortIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNewAppUserDocument = gql`
    mutation createNewAppUser {
  createNewAppUser {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNewAppUserGQL extends Apollo.Mutation<CreateNewAppUserMutation, CreateNewAppUserMutationVariables> {
    override document = CreateNewAppUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDocument = gql`
    query GetUser($customerKey: String!) {
  getCustomer(customerKey: $customerKey) {
    name
    config {
      logoPath
      defaultLanguage
      translationsPath
      useFavoritesList
      showDoorVisionBranding
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserGQL extends Apollo.Query<GetUserQuery, GetUserQueryVariables> {
    override document = GetUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }